import { Button } from "./button.styled"
import styled from "styled-components"

export const BasicButton = styled(Button)``
export const BasicFullButton = styled(BasicButton)`
  width: 100%;
`

export const LargeButton = styled(Button).attrs({ large: true })``
export const LargeFullButton = styled(LargeButton)`
  width: 100%;
`
